import ProductList from '../components/Products/ProductList';

export default function ProductListPage() {
  return <ProductList />;
}
